export default (str) => str.split('_').map((item) => `${item[0].toUpperCase()}${item.substr(1).toLowerCase()}`).join('');



// WEBPACK FOOTER //
// ./src/SharedComponents/allCapsToPascalCase.js